import { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

const AudioPlayer = ({ children }) => {
  const [currentAudio, setCurrentAudio] = useState(null);
  const [currentlyPlayingId, setCurrentlyPlayingId] = useState(null);

  const location = useLocation();

  useEffect(() => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    }

    setCurrentAudio(null);
    setCurrentlyPlayingId(null);
  }, [location]);

  // Play audio function
  const playAudioMain = (audioUrl, audioId) => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    }

    if (currentlyPlayingId === audioId) {
      setCurrentAudio(null);
      setCurrentlyPlayingId(null);
      return;
    }

    const audio = new Audio(audioUrl);
    audio.play();

    setCurrentAudio(audio);
    setCurrentlyPlayingId(audioId);

    audio.onended = () => {
      setCurrentAudio(null);
      setCurrentlyPlayingId(null);
    };
  };

  return children({ playAudioMain, currentlyPlayingId });
};

export default AudioPlayer;